import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import makeStyles from '@mui/styles/makeStyles';
import {
  DialogActionButton,
  DialogCancelButton,
} from '@/components/common/CustomDialog';
import MenuButton from '@/components/common/MenuButton';
import { useCurrentUser } from '@/lib/hooks/userData';
import translate from '@/lib/intl/translate';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import {
  CreateEditTaskDialog,
  ModalType,
  useTaskServices,
} from '@/modules/Tasks';

// This is mimicking the <MultiActionDialog> styles which uses a snowflake
// width
const useStyles = makeStyles(() => ({
  paper: {
    width: '530px',
  },
}));

type TaskMenuProps = {
  onDelete(...args: unknown[]): unknown;
  task: unknown;
};

export default function TaskMenu({ onDelete, task }: TaskMenuProps) {
  const classes = useStyles();
  const { isOrgAdmin, isOrgEditor } = useCurrentUser();
  const { deleteTask } = useTaskServices();
  const id = 'feed-slider-menu';
  const [menuAnchor, setMenuAnchor] = React.useState(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
  const openMenu = (e: any) => setMenuAnchor(e.currentTarget);
  const closeMenu = () => setMenuAnchor(null);
  const [modalType, setModalType] = React.useState('');
  const closeModal = () => setModalType('');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
  const openModal = (type: any) => setModalType(type);

  const items = [
    {
      'data-testid': 'task-menu-edit-menu-item',
      label: translate('EDIT'),
      onClick: () => {
        setMenuAnchor(null);
        openModal(ModalType.EDIT);
      },
    },
    {
      'data-testid': 'task-menu-delete-menu-item',
      label: translate('DELETE'),
      onClick: () => {
        openModal(ModalType.DELETE);
        setMenuAnchor(null);
      },
    },
  ];
  const showControls = isOrgAdmin || isOrgEditor;
  const handleDelete = () => {
    // @ts-expect-error TS(2571) TODO(ts-migrate): Object is of type 'unknown'.
    deleteTask(task.taskId);
    closeModal();
    onDelete();
  };

  return showControls ? (
    <>
      <MenuButton
        onClick={openMenu}
        className="ml-4 text-text-secondary"
        aria-controls={menuAnchor ? id : undefined}
        aria-haspopup="true"
        data-testid="task-details-menu"
      />
      <Menu
        id={id}
        onClose={closeMenu}
        open={!!menuAnchor}
        anchorEl={menuAnchor}
      >
        {items.map(({ 'data-testid': dataTestid, label, onClick }) => (
          <MenuItem key={label} onClick={onClick} data-testid={dataTestid}>
            {label}
          </MenuItem>
        ))}
      </Menu>
      <Dialog
        classes={{
          paper: `shadow-none ${classes.paper}`,
        }}
        fullWidth
        maxWidth="md"
        onClose={closeModal}
        open={!!modalType}
      >
        {modalType === ModalType.EDIT && (
          <CreateEditTaskDialog
            onClose={closeModal}
            type={ModalType.EDIT}
            // @ts-expect-error TS(2322) TODO(ts-migrate): Type 'unknown' is not assignable to type 'InferPro... Remove this comment to see the full error message
            task={task}
          />
        )}
        {modalType === ModalType.DELETE && (
          <>
            <DialogContent dividers>
              {translate('TASKS_CONFIRM_DELETE')}
            </DialogContent>
            <DialogActions className="p-2">
              <DialogCancelButton onClick={closeModal} />
              <DialogActionButton
                onClick={handleDelete}
                data-testid="task-delete-confirm-button"
              >
                {translate('DELETE')}
              </DialogActionButton>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  ) : null;
}
